/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ExternalCredentialSummary,
  ExternalCredentialSummary$inboundSchema,
} from "./externalcredentialsummary.js";

export type ListExternalCredentialsResult = {
  /**
   * The organization's external credentials.
   */
  credentials: Array<ExternalCredentialSummary>;
};

/** @internal */
export const ListExternalCredentialsResult$inboundSchema: z.ZodMiniType<
  ListExternalCredentialsResult,
  unknown
> = z.object({
  credentials: z.array(ExternalCredentialSummary$inboundSchema),
});

export function listExternalCredentialsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListExternalCredentialsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListExternalCredentialsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListExternalCredentialsResult' from JSON`,
  );
}
